import {useEffect, useRef, useState} from 'react'

import {hasBeenTriggeredInSession, openCsatPoll, rememberCsatTrigger} from './utils.js'

const DETECTION_DELAY = 500

/**
 * For debug it in devTools just add property "hjdebug" to true in "window._hjSettings"
 * `window_hjSettings.hjdebug = true`
 */
function useCsat() {
  const hjIntervalRef = useRef()

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const trigger = name => {
    if (!isMounted) return

    /** Trigger only once for session */
    if (hasBeenTriggeredInSession()) return

    /** Remember CSAT trigger for a period of time */
    rememberCsatTrigger()

    /** Trigger (open) CSAT POLL */
    hjIntervalRef.current = setInterval(function () {
      if ('hj' in window) {
        clearInterval(hjIntervalRef.current)
        openCsatPoll(name)
      }
    }, DETECTION_DELAY)
  }

  const forceTrigger = name => {
    if (!isMounted) return

    /** Trigger (open) CSAT POLL */
    hjIntervalRef.current = setInterval(function () {
      if ('hj' in window) {
        clearInterval(hjIntervalRef.current)
        openCsatPoll(name)
      }
    }, DETECTION_DELAY)
  }

  return {forceTrigger, trigger}
}

export default useCsat
